import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full overflow-y-auto"
}
const _hoisted_2 = { class: "py-4 flex flex-row justify-start items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "font-semibold text-20px mr-4 text-black-lp-200" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-row py-6 h-full"
}
const _hoisted_5 = { class: "w-2/3 px-4 text-12px xxl:text-14px" }
const _hoisted_6 = { class: "py-3" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Country ID", -1)
const _hoisted_8 = { class: "my-1 text-black-lp-300" }
const _hoisted_9 = { class: "py-3" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Country Code", -1)
const _hoisted_11 = { class: "my-1 text-gray-lp-300 px-2 inline-flex bg-gray-lp-200 rounded" }
const _hoisted_12 = { class: "py-3" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Country Name", -1)
const _hoisted_14 = { class: "my-1 text-black-lp-300" }
const _hoisted_15 = { class: "py-3" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Currency", -1)
const _hoisted_17 = { class: "my-1 text-black-lp-300" }
const _hoisted_18 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_19 = { class: "py-3" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Status Rute", -1)
const _hoisted_21 = { class: "my-1 text-black-lp-300" }
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = { class: "py-3" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal Dibuat", -1)
const _hoisted_25 = { class: "my-1 text-black-lp-300" }
const _hoisted_26 = { class: "text-gray-lp-500" }
const _hoisted_27 = { class: "py-3" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Terakhir Diubah", -1)
const _hoisted_29 = { class: "my-1 text-black-lp-300" }
const _hoisted_30 = { class: "text-gray-lp-500" }
const _hoisted_31 = { class: "py-3 inline-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_button_fill = _resolveComponent("button-fill")!

  return (_ctx.isLoading === true)
    ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
        key: 0,
        onBack: _ctx.goBack
      }, null, 8, ["onBack"]))
    : (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
            class: "w-5 mr-3 cursor-pointer",
            alt: "back"
          }),
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.dataDetail().name) + " - " + _toDisplayString(_ctx.dataDetail().code), 1)
        ]),
        (_ctx.isError)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 0,
              errorType: _ctx.errorCause,
              onTryAgain: _ctx.fetchCountryData
            }, null, 8, ["errorType", "onTryAgain"]))
          : (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode("div", _hoisted_8, _toDisplayString(_ctx.dataDetail().id), 1)
                ]),
                _createVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode("div", _hoisted_11, _toDisplayString(_ctx.dataDetail().code), 1)
                ]),
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, _toDisplayString(_ctx.dataDetail().name), 1)
                ]),
                _createVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode("div", _hoisted_17, _toDisplayString(_ctx.dataDetail().currency), 1)
                ])
              ]),
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode("div", _hoisted_21, [
                    _createVNode("div", _hoisted_22, [
                      _createVNode("div", {
                        class: 
                  `rounded-full px-2 py-0 font-medium capitalize ${
                    _ctx.dataDetail().status.toLowerCase() === 'active'
                      ? 'bg-green-lp-300'
                      : 'bg-red-lp-600'
                  } ${
                    _ctx.dataDetail().status.toLowerCase() === 'active'
                      ? 'text-green-lp-200'
                      : 'text-red-lp-500'
                  }`
                
                      }, _toDisplayString(_ctx.dataDetail().status), 3)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode("div", _hoisted_25, _toDisplayString(this.formatDate(_ctx.dataDetail().createdAt)), 1),
                  _createVNode("div", _hoisted_26, _toDisplayString(_ctx.dataDetail().createdBy), 1)
                ]),
                _createVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createVNode("div", _hoisted_29, _toDisplayString(_ctx.dataDetail().updateAt === "0001-01-01T00:00:00Z"
                ? _ctx.formatDate(_ctx.dataDetail().createdAt)
                : _ctx.formatDate(_ctx.dataDetail().updateAt)), 1),
                  _createVNode("div", _hoisted_30, _toDisplayString(_ctx.dataDetail().updatedBy), 1)
                ]),
                _createVNode("div", _hoisted_31, [
                  (_ctx.isEditAble)
                    ? (_openBlock(), _createBlock(_component_button_fill, {
                        key: 0,
                        title: "Edit",
                        class: "px-8 bg-red-lp-300",
                        onClick: () => _ctx.goEdit(_ctx.id)
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
      ]))
}